import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { StoreProvider } from "./context/StoreContext";
import { LenisProvider } from "./components/LenisProvider";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { FloatingCart } from "./components/FloatingCart";
import { QuickView } from "./components/QuickView";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Story from "./pages/Story";
import Mission from "./pages/Mission";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Policy from "./pages/Policy";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-obsidian text-ivory flex flex-col items-center justify-center gap-4 p-8 text-center">
          <p className="font-display text-2xl text-gold">ARIJ MISK</p>
          <p className="text-sm text-sand max-w-sm">Une erreur est survenue. / Something went wrong.</p>
          <button onClick={() => window.location.reload()} className="btn-gold rounded-full px-6 py-2.5 text-xs tracking-[0.25em] uppercase font-semibold">
            Recharger / Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <LenisProvider>
            <div className="grain min-h-screen bg-obsidian text-ivory">
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/story" element={<Story />} />
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/policies/:slug" element={<Policy />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <CartDrawer />
              <FloatingCart />
              <QuickView />
              <Toaster theme="dark" position="top-center" />
            </div>
          </LenisProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
